
define('jst!presence/user_list_modal/_modal',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<ul class="user-list">\n  <%- users %>\n</ul>\n');
 });

